import React, { useEffect } from 'react';
import { Box, Alert, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataManagementTab } from '@shared/components/data-management';
import { useSimpleReportsConfig } from '../config/simpleReportsConfig';
import { useContextStore } from '../../../stores/contextStore';
import { useSetPageActions } from '../../../contexts/PageActionsContext';

export const UnifiedSurveyReportManagement: React.FC = () => {
  const navigate = useNavigate();
  const { activeTenantId, activeSubjectId } = useContextStore();
  const { setHelp } = useSetPageActions();

  useEffect(() => {
    setHelp({
      title: 'Reports Guide',
      sections: [
        {
          title: 'About Reports',
          content:
            'View and manage reports generated from completed survey audits. Reports provide comprehensive analysis of survey responses with interactive charts and statistical insights.',
        },
        {
          title: 'Viewing Reports',
          content:
            'Click on any report to view detailed analysis, including response statistics, charts, and trends.',
        },
        {
          title: 'Report Generation',
          content:
            'Reports are automatically generated after survey audits are completed and published.',
        },
      ],
    });
  }, [setHelp]);

  // Hook must be called before any early returns
  const reportsConfig = useSimpleReportsConfig(
    activeSubjectId ?? '',
    activeTenantId ?? '',
    navigate
  );

  // Handle no subject selected state
  if (!activeSubjectId || !activeTenantId) {
    return (
      <Container
        maxWidth={false}
        disableGutters
        sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <Alert severity="info">
          Please select a subject to view reports.
        </Alert>
      </Container>
    );
  }

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      {/* Spacer to align with tabbed pages (matches Tabs minHeight 48px + 1px border + 12px mb) */}
      <Box sx={{ height: 49, mb: 1.5, flexShrink: 0 }} />
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <DataManagementTab config={reportsConfig} />
      </Box>
    </Container>
  );
};
